import { MockBackEndServer, RequestDataModel, ResponseDataFormat } from '@ktvs8/gocoo-engine-front-end';
import { filterMSupplierTestData, findSupplierByTicketKey } from './mock-data/MSupplier-test-data';

import { filterMProgramBySearchDay, findMProgramByTicketKey } from './mock-data/MProgram-test-data';
import { filterOrderSheetBySearchDay, findOrderSheetBySearchDay } from './mock-data/OrderSheet-test-data';

import { ApplicationUserList } from './mock-data/ApplicationUser-test-data';
import { findMProgramOrderByTicketKey } from './mock-data/MProgramOrder-test-data';
import { filterProgramBySearchDay, findProgramByTicketKey } from './mock-data/Program-test-data';
import { filterReceiptDate } from './mock-data/ReceiptDate-test-data';

export class MockBacEndServerClass implements MockBackEndServer {
  constructor() {}
  /**
   * listViewの処理
   * @param requestModel
   * @param messageService
   * @returns
   */
  search(requestModel: RequestDataModel): ResponseDataFormat {
    let responseData: ResponseDataFormat = {
      isCompleted: true,
      errorMessageList: [],
      data: null,
    };

    if (requestModel.dataType === 'Program') {
      responseData.data = {
        DataList: filterProgramBySearchDay(requestModel),
        LastPage: true,
        NextPaginationStartKey: {},
        HitsRequestLimiter: false,
      };
    }

    if (requestModel.dataType === 'ReceiptDate') {
      responseData.data = {
        DataList: filterReceiptDate(requestModel),
        LastPage: true,
        NextPaginationStartKey: {},
        HitsRequestLimiter: false,
      };
    }

    if (requestModel.dataType === 'OrderSheet') {
      responseData.data = {
        DataList: filterOrderSheetBySearchDay(requestModel),
        LastPage: true,
        NextPaginationStartKey: {},
        HitsRequestLimiter: false,
      };
    }
    if (requestModel.dataType === 'MSupplier') {
      responseData.data = {
        DataList: filterMSupplierTestData(requestModel),
        LastPage: true,
        NextPaginationStartKey: {},
        HitsRequestLimiter: false,
      };
    }
    if (requestModel.dataType === 'MProgram') {
      responseData.data = {
        DataList: filterMProgramBySearchDay(requestModel),
        LastPage: true,
        NextPaginationStartKey: {},
        HitsRequestLimiter: false,
      };
    }

    return responseData;
  }

  /**
   * レコード１件を取得する
   * @param requestModel
   * @returns
   */
  getRecord(requestModel: RequestDataModel): ResponseDataFormat {
    let responseData: ResponseDataFormat = {
      isCompleted: true,
      errorMessageList: [],
      data: null,
    };

    if (requestModel.dataType === 'Program') {
      responseData.data = findProgramByTicketKey(requestModel);
    }

    if (requestModel.dataType === 'MSupplier') {
      responseData.data = findSupplierByTicketKey(requestModel);
    }
    if (requestModel.dataType === 'OrderSheet') {
      responseData.data = findOrderSheetBySearchDay(requestModel);
    }
    if (requestModel.dataType === 'MProgram') {
      // responseData.data = filterMProgramBySearchDay(requestModel);
      responseData.data = findMProgramByTicketKey(requestModel);
    }
    if (requestModel.dataType === 'MProgramOrder') {
      responseData.data = findMProgramOrderByTicketKey(requestModel);
    }
    return responseData;
  }

  registerRecord(requestModel: RequestDataModel): ResponseDataFormat {
    return {
      isCompleted: true,
      errorMessageList: [],
      data: null,
    };
  }

  deleteRecord(requestModel: RequestDataModel): ResponseDataFormat {
    return {
      isCompleted: true,
      errorMessageList: [],
      data: null,
    };
  }

  getKeyAndValueList(requestModel: RequestDataModel): ResponseDataFormat {
    return {
      isCompleted: true,
      errorMessageList: [],
      data: {},
    };
  }
  downloadFile(requestModel: RequestDataModel): ResponseDataFormat {
    return {
      isCompleted: true,
      errorMessageList: [],
      data: null,
    };
  }
  printFile(requestModel: RequestDataModel): ResponseDataFormat {
    return {
      isCompleted: true,
      errorMessageList: [],
      data: null,
    };
  }
  original(requestModel: RequestDataModel): ResponseDataFormat {
    return {
      isCompleted: true,
      errorMessageList: [],
      data: null,
    };
  }
  /**
   * アプリケーションユーザー一覧を取得する
   * @param requestModel
   * @returns
   */
  getApplicationUserList(requestModel: RequestDataModel): ResponseDataFormat {
    return {
      isCompleted: true,
      errorMessageList: [],
      data: {
        DataList: ApplicationUserList,
        LastPage: true,
        NextPaginationStartKey: {},
        HitsRequestLimiter: false,
      },
    };
  }

  uploadFile(requestModel: RequestDataModel): ResponseDataFormat {
    throw new Error('Method not implemented.');
  }
  getInputSuggestions(requestModel: RequestDataModel): ResponseDataFormat {
    throw new Error('Method not implemented.');
  }
  getRelationalList(requestModel: RequestDataModel): ResponseDataFormat {
    throw new Error('Method not implemented.');
  }
  sendEMail(requestModel: RequestDataModel): ResponseDataFormat {
    throw new Error('Method not implemented.');
  }
  getApplicationTRoleInfo(requestModel: RequestDataModel): ResponseDataFormat {
    throw new Error('Method not implemented.');
  }
  registerApplicationUser(requestModel: RequestDataModel): ResponseDataFormat {
    throw new Error('Method not implemented.');
  }
  getApplicationUserInfo(requestModel: RequestDataModel): ResponseDataFormat {
    throw new Error('Method not implemented.');
  }
}
